import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { toast, Zoom } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const SuccessMessage = (message) => {
  return message;
};

const ErrorMessage = (message) => {
  console.error('Error:', message);
  return message;
};

const WarningMessage = (message) => {
  console.warn('Warning:', message);
  return message;
};

const InfoMessage = (message) => {
  console.info('Info:', message);
  return message;
};
const removeAuth = () => {
  localStorage.removeItem('userData')
  localStorage.removeItem('accessToken');

}


const Apiloader = ({ type }) => {
  return (
    <div className="loading-wrapper">
      <div className="spinner"></div>
      <p className="text-white mt-3">Loading {type}...</p>
    </div>
  );
};

export const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

export const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
};

export const truncateText = (text, wordLimit = 10) => {
  if (!text) return '';
  const words = text.split(' ');
  if (words.length <= wordLimit) return text;
  return words.slice(0, wordLimit).join(' ') + '...';
};

export const STATUS_CONFIG = {
  PAYMENT: {
    HELD: {
      label: 'Hold',
      color: '#CC9814',
      badgeClass: 'badge',
      textColor: '#ffffff'
    },
    RELEASED: {
      label: 'Released',
      color: '#059126d0',
      badgeClass: 'badge',
      textColor: '#ffffff'
    },
    REFUND: {
      label: 'Refunded',
      color: '#2563EB',
      badgeClass: 'badge',
      textColor: '#ffffff'
    },
    CANCELLED: {
      label: 'Cancelled',
      color: '#f56876',
      badgeClass: 'badge bg-danger',
      textColor: '#ffffff'
    },
  },
  CUSTOMER: {
    ACTIVE: {
      label: 'Active',
      color: '#059126d0',
      badgeClass: 'badge',
      textColor: '#ffffff'
    },
    INACTIVE: {
      label: 'Inactive',
      color: '#f56876',
      badgeClass: 'badge bg-danger',
      textColor: '#fc0000'
    },
  },
  DRIVER: {
    available: {
      label: 'Available',
      color: '#059126d0',
      badgeClass: 'badge',
      textColor: '#ffffff'
    },
    on_trip: {
      label: 'On Trip',
      color: '#3bcae0',
      badgeClass: 'badge bg-info',
      textColor: '#ffffff'
    },
    off_duty: {
      label: 'Off Duty',
      badgeClass: 'badge warning',
    },
    inactive: {
      label: 'Inactive',
      color: '#f56876',
      badgeClass: 'badge bg-danger',
      textColor: '#fc0000'
    },
  },
  FLEET: {
    available: {
      label: 'Available',
      color: '#059126d0',
      badgeClass: 'badge',
      textColor: '#ffffff'
    },
    on_trip: {
      label: 'On Trip',
      color: '#3bcae0',
      badgeClass: 'badge bg-info',
      textColor: '#ffffff'
    },
    inactive: {
      label: 'Inactive',
      color: '#f56876',
      badgeClass: 'badge bg-danger',
      textColor: '#fc0000'
    },
    maintenance: {
      label: 'Maintenance',
      badgeClass: 'badge warning',
    },
  },
  CARGO_TYPE: {
    ACTIVE: {
      label: 'Active',
      color: '#059126d0',
      badgeClass: 'badge',
      textColor: '#ffffff'
    },
    INACTIVE: {
      label: 'Inactive',
      color: '#f56876',
      badgeClass: 'badge bg-danger',
      textColor: '#fc0000'
    }
  },
  SHIPPER: {
    ACTIVE: {
      label: 'Active',
      color: '#059126d0',
      badgeClass: 'badge',
      textColor: '#ffffff'
    },
    INACTIVE: {
      label: 'Inactive',
      color: '#f56876',
      badgeClass: 'badge bg-danger',
      textColor: '#fc0000'
    },
    SUSPENDED: {
      label: 'Suspended',
      color: '#bb07d3',
      badgeClass: 'badge',
      textColor: '#ffffff'
    },
    PENDING: {
      label: 'Pending',
      badgeClass: 'badge warning',
    }
  },
  BUSINESS_TYPES: {
    FTL: {
      label: 'FTL',
      color: '#059126d0',
      badgeClass: 'badge bg-success',
      textColor: '#ffffff'
    },
    LTL: {
      label: 'LTL',
      color: '#2196F3',
      badgeClass: 'badge bg-primary',
      textColor: '#ffffff'
    },
    EXPRESS_DELIVERY: {
      label: 'Express Delivery',
      color: '#FF9800',
      badgeClass: 'badge bg-warning',
      textColor: '#212529'
    },
    LAST_MILE_DELIVERY: {
      label: 'Last Mile Delivery',
      color: '#9C27B0',
      badgeClass: 'badge bg-purple',
      textColor: '#ffffff'
    },
    TEMPERATURE_CONTROLLED: {
      label: 'Temperature Controlled',
      color: '#00BCD4',
      badgeClass: 'badge bg-info',
      textColor: '#ffffff'
    },
    HAZMAT: {
      label: 'Hazmat',
      color: '#F44336',
      badgeClass: 'badge bg-danger',
      textColor: '#ffffff'
    },
    OVER_DIMENSIONAL: {
      label: 'Over Dimensional',
      color: '#FF5722',
      badgeClass: 'badge bg-orange',
      textColor: '#ffffff'
    },
    FLATBED: {
      label: 'Flatbed',
      color: '#795548',
      badgeClass: 'badge bg-brown',
      textColor: '#ffffff'
    },
    CAR_CARRIER: {
      label: 'Car Carrier',
      color: '#607D8B',
      badgeClass: 'badge bg-blue-grey',
      textColor: '#ffffff'
    },
    MOVING_RELOCATION: {
      label: 'Moving Relocation',
      color: '#E91E63',
      badgeClass: 'badge bg-pink',
      textColor: '#ffffff'
    },
    COURIER_SERVICE: {
      label: 'Courier Service',
      color: '#3F51B5',
      badgeClass: 'badge bg-indigo',
      textColor: '#ffffff'
    },
    _3PL: {
      label: '3PL',
      color: '#009688',
      badgeClass: 'badge bg-teal',
      textColor: '#ffffff'
    },
    OTHER: {
      label: 'Other',
      color: '#9E9E9E',
      badgeClass: 'badge bg-secondary',
      textColor: '#ffffff'
    }
  }
};

export const getStatusConfig = (entityType, status) => {
  if (!entityType || !status) return getDefaultStatusConfig(status);

  const entityConfig = STATUS_CONFIG[entityType?.toUpperCase()];
  if (!entityConfig) return getDefaultStatusConfig(status);

  if (entityConfig[status]) {
    return entityConfig[status];
  }

  const upperStatus = status?.toUpperCase();
  if (entityConfig[upperStatus]) {
    return entityConfig[upperStatus];
  }

  const lowerStatus = status?.toLowerCase();
  if (entityConfig[lowerStatus]) {
    return entityConfig[lowerStatus];
  }

  return getDefaultStatusConfig(status);
};


const getDefaultStatusConfig = (status) => ({
  label: status || 'Unknown',
  color: '#6c757d',
  badgeClass: 'badge bg-secondary',
  textColor: '#ffffff'
});

export { ErrorMessage, WarningMessage, InfoMessage, SuccessMessage, removeAuth, Apiloader };
